import { Show, TabbedShowLayout, useTranslate } from 'react-admin';
import { Box, Card, CardContent, Typography, Divider } from '@mui/material';
import {
  ContactHeader,
  ContactDetails,
  ContactIdentities,
  ContactConversations,
} from './components';

export const ContactShow = () => {
  const translate = useTranslate();

  return (
    <Show>
      <Box p={2}>
        <ContactHeader />

        <TabbedShowLayout>
          <TabbedShowLayout.Tab label={translate('resources.contact.tabs.details')}>
            <Box display="grid" gridTemplateColumns="2fr 1fr" gap={2}>
              <ContactDetails />
              <Card variant="outlined">
                <CardContent>
                  <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                    {translate('resources.contact.tabs.identities')}
                  </Typography>
                  <Divider sx={{ my: 1 }} />
                  <ContactIdentities />
                </CardContent>
              </Card>
            </Box>
          </TabbedShowLayout.Tab>

          <TabbedShowLayout.Tab label={translate('resources.contact.tabs.conversations')}>
            <ContactConversations />
          </TabbedShowLayout.Tab>
        </TabbedShowLayout>
      </Box>
    </Show>
  );
};
